function mountText(text, container) {
    const el = document.createTextNode(text);
    container.appendChild(el);
}

function mountElement(vNode, container) {
    const el = document.createElement(vNode.tag);
    const attrList = vNode.attrs;
    if (Array.isArray(attrList) && attrList.length != 0) {
        attrList.forEach((attr, index) => {
            let arrtKey = attr.name;
            let attrVal = attr.value;
            patchElement(el, arrtKey, attrVal);
        });
    }
    container.appendChild(el);
    return el;
}

function patchElement(el, key, value) {
    switch (key) {
        case "style":
            el.style = value;
            break;
        default:
            el.setAttribute(key, value);
            break;
    }
}

let mount = (vNodeList, container) => {
    if (Array.isArray(vNodeList) && vNodeList.length != 0) {
        vNodeList.forEach((item, index) => {
            const vNode = item;
            if (typeof vNode === "object") {
                let el = mountElement(vNode, container);
                mount(vNode.children, el);
            } else if (typeof vNode === "string") {
                mountText(vNode, container);
            }
        });
    }
};

export { mount };
